module.exports = __webpack_public_path__ + "static/media/SmartShop_7-767w.48b9c5d9.jpg";